/* Mobile media slider for gender-specific card media (custom.card_media_male /
   custom.card_media_female). Desktop never initializes this — it shows the
   static primary/hover markup instead. Hook: [data-card-media-slider]. */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  /* Custom fixed-width marker that moves along the track (Figma), instead of
     Swiper's built-in progressbar pagination — that type animates as a
     growing fill from 0-100%, which is a different behavior than what's
     wanted here. The track (data-card-media-progress) stays fully grey at
     all times; only the marker's width/position change. */
  function updateProgressMarker(swiper, progressEl) {
    if (!progressEl) return;
    var marker = progressEl.querySelector('[data-card-media-progress-marker]');
    if (!marker) return;

    /* Swiper leaves `slides` empty when it initializes inside a hidden
       container (the CLP grid is display:none while #ProductGridContainer has
       .loading), so fall back to counting the slide elements directly —
       otherwise the marker stays at 100% until the first slideChange. */
    var count = swiper.slides && swiper.slides.length
      ? swiper.slides.length
      : (swiper.el ? swiper.el.querySelectorAll('.swiper-slide').length : 1);
    if (!count || count < 1) count = 1;

    marker.style.width = (100 / count) + '%';
    marker.style.transform = 'translateX(' + (swiper.activeIndex * 100) + '%)';
  }

  function initSlider(root) {
    if (!root || root.cardMediaSwiper || typeof Swiper === 'undefined') return;

    /* The progress bar is a sibling of the slider (rendered below the media,
       not overlaid on it — see snippets/card-product-tagged.liquid), so it's
       looked up via the enclosing card rather than inside `root`. */
    var card = root.closest('product-card, .product-card');
    var progressEl = card ? card.querySelector('[data-card-media-progress]') : null;

    var options = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
      a11y: { enabled: true },
      on: {
        init: function (swiper) { updateProgressMarker(swiper, progressEl); },
        slideChange: function (swiper) { updateProgressMarker(swiper, progressEl); },
        update: function (swiper) { updateProgressMarker(swiper, progressEl); }
      }
    };

    root.cardMediaSwiper = new Swiper(root, options);
  }

  function destroySlider(root) {
    if (root && root.cardMediaSwiper) {
      root.cardMediaSwiper.destroy(true, true);
      root.cardMediaSwiper = null;
    }
  }

  function syncBreakpoint(root) {
    if (window.matchMedia(MOBILE_QUERY).matches) {
      initSlider(root);
    } else {
      destroySlider(root);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-card-media-slider]');
    for (var i = 0; i < roots.length; i++) {
      syncBreakpoint(roots[i]);
    }
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target && event.target.querySelectorAll
      ? event.target.querySelectorAll('[data-card-media-slider]')
      : [];
    for (var i = 0; i < roots.length; i++) {
      destroySlider(roots[i]);
    }
  });

  /* Exposed so assets/card-product-color-swatches.js can rebuild a card's
     slides after a swatch swap without re-implementing Swiper lifecycle rules. */
  window.CardMediaGenderSlider = {
    destroy: destroySlider,
    sync: syncBreakpoint,
    updateProgressMarker: updateProgressMarker
  };
})();
